import { useMutation, useQueryClient } from '@tanstack/react-query';
import { formatCount, formatTaka } from '@/utils/number';
import { disbursePcmpAccountsBatch } from '../api/pcmpAccounts.api';
import type {
  PcmpAccountsDisbursePayload,
  PcmpAccountsDisburseResult,
} from '../types/pcmpAccounts.types';
import { pcmpActionCallbacks } from '../utils/pcmpActionCallbacks';

export function useDisbursePcmpAccountsBatch(
  batchNo: number,
  onSuccess: (result: PcmpAccountsDisburseResult) => void,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PcmpAccountsDisbursePayload) =>
      disbursePcmpAccountsBatch(batchNo, payload),
    ...pcmpActionCallbacks<PcmpAccountsDisburseResult>(
      queryClient,
      (result) =>
        `${formatCount(result.disbursed.length, 'proposal')} disbursed (${formatTaka(
          result.disbursedAmount,
        )})`,
      onSuccess,
    ),
  });
}
